// pages/Students.jsx

import React from "react";
import { Table, Input, Button, Modal } from "antd";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import useStudents from "../../../hooks/AdminDashboard/useStudents";

function Students() {
	const {
		setSearchTerm,
		isModalVisible,
		modalType,
		selectedStudent,
		filteredStudents,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		enrollmentData,
	} = useStudents();

	const columns = [
		{ title: "Student Name", dataIndex: "fullName", key: "fullName" },
		{ title: "Email", dataIndex: "email", key: "email" },
		{
			title: "Actions",
			key: "actions",
			render: (_, record) => (
				<span className="space-x-2">
					<Button
						icon={<EyeOutlined />}
						onClick={() => showModal("view", record)}
					/>
					<Button
						icon={<DeleteOutlined />}
						onClick={() => showModal("delete", record)}
						danger
					/>
				</span>
			),
		},
	];

	const renderFormContent = () => {
		switch (modalType) {
			case "view":
				return (
					<div>
						<p>
							<strong>Name:</strong> {selectedStudent.fullName}
						</p>
						<p>
							<strong>Email:</strong> {selectedStudent.email}
						</p>
						{enrollmentData.length > 0 ? (
							enrollmentData.map((enrollment) => (
								<div key={enrollment._id}>
									<p>
										<strong>Enrolled Courses:</strong>{" "}
										{enrollment?.classroomId?.courseId.name}
									</p>
									<p>
										<strong>enrollment Date:</strong>{" "}
										{enrollment.enrollmentDate}
									</p>
									<p>
										<strong>PaymentStatus:</strong>{" "}
										{enrollment.paymentStatus}
									</p>
								</div>
							))
						) : (
							<p>No enrolled courses</p>
						)}
					</div>
				);
			case "delete":
				return <p>Are you sure you want to delete this student?</p>;
			default:
				return null;
		}
	};

	return (
		<div className="p-6 bg-white">
			<h2 className="text-2xl font-bold mb-4">Students List</h2>

			<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
				<Input.Search
					placeholder="Search by student name..."
					onChange={(e) => setSearchTerm(e.target.value)}
					className="w-full"
				/>
			</div>

			<Table
				columns={columns}
				dataSource={filteredStudents}
				rowKey="_id"
				pagination={{ position: ["bottomRight"] }}
				className="w-full"
			/>

			<Modal
				title={`${
					modalType.charAt(0).toUpperCase() + modalType.slice(1)
				} Student`}
				open={isModalVisible}
				onOk={handleModalConfirm}
				onCancel={handleModalCancel}
				okText={modalType === "delete" ? "Confirm" : "view"}
				cancelText="Cancel"
				destroyOnClose
			>
				{renderFormContent()}
			</Modal>
		</div>
	);
}

export default Students;
